import React, { useEffect, useRef, useState } from 'react';
import api from '@/api/client';

export function useSiteContent(page, fallback = null) {
  const [content, setContent] = useState(fallback);
  useEffect(() => {
    let active = true;
    api.get(`/public/site-content/${page}`).then(r => { if (active) setContent(r.data.content); }).catch(() => {});
    return () => { active = false; };
  }, [page]);
  return content;
}

export function Reveal({ children, className = '', delay = 0, as: Tag = 'div' }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { el.classList.add('is-visible'); obs.unobserve(el); }
    }, { threshold: 0.12 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return <Tag ref={ref} className={`reveal ${className}`} style={{ transitionDelay: `${delay}ms` }}>{children}</Tag>;
}

export function SectionLabel({ index, children }) {
  return (
    <div className="flex items-center gap-3 mb-6">
      {index && <span className="text-xs font-semibold tabular-nums" style={{ color: '#000' }}>({index})</span>}
      <span className="w-8 h-px" style={{ backgroundColor: '#000' }} />
      <span className="text-xs uppercase tracking-[0.25em]" style={{ color: '#666' }}>{children}</span>
    </div>
  );
}
